import { Injectable } from '@angular/core';
import type { PalantirDialogRef } from '../dialog/dialog-ref.service';
import { PalantirDialogService } from '../dialog/dialog.service';
import { PalantirConfirmDialogComponent } from './confirm-dialog.component';
import type { PalantirConfirmDialogOptions } from './confirm-dialog.type';

@Injectable({
  providedIn: 'root',
})
export class PalantirConfirmDialogService {
  public constructor(private readonly palantirDialogService: PalantirDialogService) {}

  public openDialog(params?: PalantirConfirmDialogOptions): PalantirDialogRef<
    | {
        role: 'cancel' | 'success';
      }
    | undefined
  > {
    return this.palantirDialogService.openDialog(PalantirConfirmDialogComponent, {
      size: 'small',
      data: params,
    });
  }
}
